import i from"styled-components";const t={portrait:{width:"10px",height:"16px"},landscape:{width:"16px",height:"10px"},squarish:{width:"16px",height:"16px"}},e={landscape:{height:"80px"},portrait:{height:"160px"},squarish:{height:"117px"}},o={unsplash:{height:"192.5px"},iconLibrary:{height:"40px"},library:{height:"80.5px"},fromPage:{height:"138.5px"},upload:{height:"83.5px"}},r=i.aside`
	position: fixed;
	inset-block: 0;
	right: 0;
	width: 400px;
	box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 20px 0px;
	border-left: 1px solid rgba(0, 0, 0, 0.1);
	background-color: ${({theme:i})=>i.bg.general};
	padding: 20px;
	box-sizing: border-box;
	z-index: 50;
`;i.div`
	position: relative;
	padding: 20px;
	height: 100%;
	box-sizing: border-box;
	overflow-y: auto;
`;const p=i.div`
	cursor: pointer;
	border-radius: 50%;
	position: fixed;
	height: 23px;
	width: 23px;
	margin-left: -32px;
	background: ${({theme:i})=>i.bg.primary};
	box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 7px;
`,d=i.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`,a=i.div`
	display: flex;
	border-bottom: 2px solid ${({theme:i})=>i.border.black15};
	gap: 12px;
`,n=i.span`
	font-size: 13px;
	border-bottom: 2px solid
		${({isActive:i,theme:t})=>i?t.text.title:"transparent"};
	color: ${({theme:i})=>i.text.title};
	opacity: ${({isActive:i})=>i?1:.5};
	padding-bottom: 8px;
	cursor: pointer;
	margin-bottom: -2px;
	font-family: 'PP Formula';
	user-select: none;
`,l=i.div`
	display: flex;
	gap: 16px;
`,x=i.div`
	flex: 1;
`,g=i.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	padding: 12px;
	background-color: ${({theme:i})=>i.bg.primary};
	border-radius: 8px;
	gap: 12px;
`,c=i.div`
	display: grid;
	place-content: center;
`,s=i.div`
	width: ${({orientation:i})=>t[i].width};
	height: ${({orientation:i})=>t[i].height};
	background-color: #7a869a;
	border-radius: 2px;
	opacity: ${({isActive:i})=>i?1:.5};
	cursor: pointer;
`,b=i.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`,h=i.div`
	position: relative;
	height: ${({tab:i,offset:t="0px"})=>`calc(100vh - ${o[i].height} - ${t}) `};
	overflow-y: auto;
`,m=i.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 4px;
	overflow-y: auto;
	position: relative;
`,u=i.img`
	object-fit: cover;
	width: 100%;
	height: ${({orientation:i})=>e[i].height};
	cursor: pointer;
	border-radius: 4px;
`,f=i.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	justify-content: space-between;
	align-items: center;
	padding: 16px 8px;
	border-radius: 16px;
	background: #fbfbfa;
	overflow: hidden;
	color: #171717;
	text-align: center;
	text-overflow: ellipsis;
	font-family: 'SF Pro';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`,v=i.img`
	width: 45px;
	height: 45px;
	cursor: pointer;
`;i.img`
	object-fit: cover;
	width: 32px;
	height: 32px;
	cursor: pointer;
	border-radius: 4px;
`;const y=i.div`
	position: absolute;
	inset: 0;
	display: grid;
	place-content: center;
	z-index: 10;
`,z=i.div`
	width: 24px;
	height: 24px;
`,M=i.button`
	grid-column: 2 / 2;
	color: ${({theme:i})=>i.border.black50};
	background: none;
	border: none;
	cursor: pointer;
	font-weight: 500;
`,I=i.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`,w=i.p`
	font-size: 14px;
	color: #c9372c;
	margin: 0;
`,j=i.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	text-align: center;
`,N=i.h1`
	margin: 0;
	font-size: 16px;
	font-weight: 500;
	color: ${({theme:i})=>i.text.text};
`,k=i.p`
	margin: 0;
	font-size: 14px;
	font-weight: 400;
	color: ${({theme:i})=>i.text.text};
`,Z=i.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,$=i.h1`
	font-size: 14px;
	color: ${({theme:i})=>i.text.text};
	margin: 0;
	font-weight: 500;
`,A=i.button`
	font-size: 13px;
	font-family: PP Formula;
	color: #fff;
	font-weight: 500;
	padding: 8px 16px;
	border-radius: 9999px;
	background-color: #000;
	width: fit-content;
	cursor: pointer;
	align-self: center;
	border: none;
`,D=i.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`,S=i.div`
	height: 150px;
	border-radius: 8px;
	border: 1px dashed ${({theme:i})=>i.border.black15};
	width: 100%;
	background-color: ${({theme:i})=>i.bg.primary};
	display: grid;
	place-content: center;
	text-align: center;
	gap: 8px;
	cursor: ${({isDisabled:i})=>i?"no-drop":"default"};
	opacity: ${({isDisabled:i})=>i?"0.5":"1"};
	pointer-events: ${({isDisabled:i})=>i?"none":"auto"};
	box-sizing: border-box;
	border: 1px dashed
		${({isDraggingOver:i,theme:t})=>i?t.bg.brand:t.bg.hover};

	${({isDraggingOver:i})=>i?"\n\t\t\t\tbackground: linear-gradient(\n\t\t\t\t\t267deg,\n\t\t\t\t\trgba(21, 105, 255, 0.2) 4.72%,\n\t\t\t\t\trgba(0, 209, 195, 0.2) 103.02%\n\t\t\t\t);\n\t\t\t\tborder-color: rgba(255, 255, 255.5);\n\t\t\t":""}
`,W=i.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 150px;
	width: 230px;
	border-radius: 15px;
	background: url(${({image:i})=>i});
	background-size: cover;
	cursor: pointer;

	svg {
		z-index: 1;
	}

	&:hover {
		&:after {
			background: rgba(0, 0, 0, 0.15) !important;
		}
	}

	&:after {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: 15px;
		background: rgba(0, 0, 0, 0.12);
	}
`,G=i.div``,P=i.div`
	.focal-point-root {
		max-width: 100%;
	}
	.focal-point-image {
		border-radius: 15px;
	}
	.focal-point-button {
		width: 24px;
		height: 24px;
		border-radius: 4px;
		border: none;
		background-color: ${({theme:i})=>i.border.black15};

		&::after {
			position: absolute;
			content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfOTI4Nl8xMzEzNSkiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTAuMDAwMyAxOC4zMzM0QzE0LjYwMjcgMTguMzMzNCAxOC4zMzM3IDE0LjYwMjUgMTguMzMzNyAxMC4wMDAxQzE4LjMzMzcgNS4zOTc3MSAxNC42MDI3IDEuNjY2NzUgMTAuMDAwMyAxLjY2Njc1QzUuMzk3OTUgMS42NjY3NSAxLjY2Njk5IDUuMzk3NzEgMS42NjY5OSAxMC4wMDAxQzEuNjY2OTkgMTQuNjAyNSA1LjM5Nzk1IDE4LjMzMzQgMTAuMDAwMyAxOC4zMzM0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMTguMzMzMyAxMEgxNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNNS4wMDAzMyAxMEgxLjY2Njk5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzQiIGQ9Ik0xMCA1LjAwMDA4VjEuNjY2NzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfNSIgZD0iTTEwIDE4LjMzMzNWMTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfOTI4Nl8xMzEzNSI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K');
			top: 2px;
			right: 0px;
			left: 0px;
			bottom: 0px;
		}
	}
`,C=i.div`
	position: relative;
	border-radius: 15px;
`,L=i.div`
	position: absolute;
	right: 0;
	top: -35px;
`,H=i.div`
	display: flex;
	align-items: center;
	column-gap: 8px;
`,J=i.div`
	color: ${({theme:i})=>i.text.text};
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
`,B=i.div`
	display: grid;
	grid-template-columns: 20px auto;
	align-items: flex-start;
	column-gap: 4px;
	margin-top: 7px;
`,Y=i.img`
	position: relative;
	user-select: none;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 15px;
`,R=i.div`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: center;
	row-gap: 12px;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
`,U=i.div`
	border-radius: 15px;
	position: relative;

	.buttons {
		visibility: hidden;
	}

	svg {
		z-index: 1;
	}

	&:hover {
		.buttons {
			visibility: visible;
		}
	}
`,T=i.div`
	opacity: 0.5;
	background: ${({theme:i})=>i.border.black15};
	width: 100%;
	height: 1px;
`;i.div`
	padding-top: 15px;
`,i.div`
	font-size: 14px;
	line-height: 14px;
	color: #07145a;

	display: flex;
	align-items: center;
	column-gap: 15px;
`;const Q=i.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	height: ${({tab:i,offset:t="0px"})=>`calc(100vh - ${o[i].height} - ${t}) `};
	overflow-y: auto;
`,E=i.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,V=i.h1`
	margin: 0;
	font-size: 14px;
	color: #3b3b3b;
`,O=i.img`
	border-radius: 4px;
`,F=i.span`
	color: #3b3b3b;
	font-size: 14px;
`,X=i.span`
	color: rgba(0, 0, 0, 0.5);
	font-size: 14px;
`,K=i.div`
	color: ${({theme:i})=>i.text.text};
	font-family: 'SF Pro Display';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 16.8px */
`,q=i.div`
	display: flex;
	flex-flow: row;
	gap: 5px;
	align-items: center;
	padding: 4px 8px;
	height: 40px;
	background-color: ${({theme:i})=>i.bg.primary};
	border-radius: 8px;
	box-sizing: border-box;
	border: none;
	width: 100%;

	&:focus {
		outline: ${({theme:i})=>`2px solid ${i.text.brand}4d`};
		outline-offset: 1px;
		background-color: ${({theme:i})=>i.bg.general};
	}
`,_=i.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	font-size: 14px;
	color: ${({theme:i})=>i.text.text};
`,ii=i.img`
	height: 32px;
	width: 32px;
`;export{Q as AtlassianUploadContainer,R as ButtonsContainer,p as CloseSidebarContainer,x as ColorsFilterContainer,L as CompleteRepositionContainer,T as Divider,S as DropZoneContainer,l as FiltersContainer,H as FlexAlign,P as FocalPointContainer,D as FromPageContainer,B as Grid,q as IconContainer,ii as IconImg,f as IconPlaceholder,v as IconPlaceholderThumbnail,_ as IconTitle,Y as Image,W as ImageContainer,U as ImagePreview,C as ImageRepositionContainer,d as ImagesSidebarContainer,A as LinkButton,I as LinkContainer,w as LinkError,Z as LinkPreviewContainer,$ as LinkPreviewHeading,j as MessageContainer,k as MessageDescription,N as MessageHeading,K as NoPageSelectedMessage,s as Orientation,c as OrientationContainer,g as OrientationFilterContainer,G as ParentContainer,M as ShowMoreButton,r as SidebarContainer,z as SpinnerContainer,n as Tab,a as TabsContainer,J as Text,u as Thumbnail,h as ThumbnailsContainer,m as ThumbnailsGridContainer,y as ThumbnailsStatusContainer,b as UnsplashContainer,E as UploadPreviewContainer,V as UploadPreviewHeading,O as UploadPreviewImage,F as UploadPreviewName,X as UploadPreviewSize};
